import script from "./RegisterByInvitationCode.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterByInvitationCode.vue?vue&type=script&setup=true&lang=js"

import "./RegisterByInvitationCode.vue?vue&type=style&index=0&id=4abcc9f0&scoped=true&lang=css"

import exportComponent from "../../../consumer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4abcc9f0"]])

export default __exports__